export default __webpack_public_path__ + "static/skin-side-up-dc8956e5bee0d894fbd5532305e41d5b.png";